import { Checkbox, Token, Tooltip } from "@chaser/components";
import styles from "./RoleUsersModal.module.scss";

function getInitials(name) {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 0 || !parts[0]) return "?";
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

const AVATAR_COLORS = [
  "#E07C4F",
  "#5B8DEF",
  "#6BBF6A",
  "#D45D79",
  "#9B72CF",
  "#E6A23C",
  "#3AAFA9",
  "#CF6A87",
  "#7C8DBF",
  "#D4A15A",
];

function avatarColor(identifier) {
  let hash = 0;
  for (let i = 0; i < identifier.length; i++) {
    hash = identifier.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

const RoleUsersModalUserRow = ({
  user,
  showCheckbox,
  checked,
  disabled,
  disabledReason,
  onToggle,
}) => {
  const identifier = user.email || user.name;
  const initials = user.verified
    ? getInitials(user.name || user.email)
    : getInitials(user.email);
  const color = avatarColor(identifier);

  const row = (
    <div
      className={`${styles.userRow} ${showCheckbox && !disabled ? styles.userRowClickable : ""}`}
      onClick={showCheckbox && !disabled ? () => onToggle(user.key) : undefined}
    >
      {showCheckbox && (
        <Checkbox
          checked={checked}
          disabled={disabled}
          onChange={() => onToggle(user.key)}
          className={styles.checkbox}
        />
      )}
      <div className={styles.avatar} style={{ backgroundColor: color }}>
        {initials}
      </div>
      <div className={styles.userInfo}>
        {user.verified ? (
          <>
            <span className={styles.userName}>{user.name || user.email}</span>
            <span className={styles.userEmail}>{user.email}</span>
          </>
        ) : (
          <span className={styles.userName}>{user.email}</span>
        )}
      </div>
      {!user.verified && (
        <Token
          size="narrow"
          backgroundColor="Light Neutral 2"
          borderColor="Mid Neutral 3"
          color="Dark Neutral 2"
        >
          Not verified
        </Token>
      )}
    </div>
  );

  if (disabled && disabledReason) {
    return <Tooltip content={disabledReason}>{row}</Tooltip>;
  }

  return row;
};

export default RoleUsersModalUserRow;
